export default "__VITE_ASSET__tLo_M46U__"